import Box from '@mui/material/Box'
import { makeStyles } from 'tss-react/mui'

import HelpDropDown from './TopNav/HelpDropDown'

const useStyles = makeStyles()(() => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'start',
    paddingTop: '50px',
    backgroundColor: '#17BCC9',
    height: '320px',
  },
  helpDropdown: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
}))

export const AccountSelector = ({ children }) => {
  const { classes } = useStyles()

  return (
    <Box className={classes.wrapper}>
      {children}
      <Box className={classes.helpDropdown}>
        <HelpDropDown />
      </Box>
    </Box>
  )
}

export default AccountSelector
